import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-achievments',
  templateUrl: './achievments.component.html',
  styleUrls: ['./achievments.component.scss']
})
export class AchievmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
